<div class="ds-form-control__wrapper">
    <ng-container *ngIf="label">
        <label class="ds-form-control__label" [for]="id">{{ label }}</label>
    </ng-container>

    <mat-form-field class="ds-form-control__item" appearance="outline" subscriptSizing="dynamic">
        <input
            [id]="id"
            #input
            matInput
            [max]="max"
            [min]="min"
            [attr.aria-label]="ariaLabel"
            [attr.aria-labelledby]="ariaLabelledby"
            [attr.autocomplete]="autocomplete"
            [attr.maxlength]="maxlength"
            [attr.minlength]="minlength"
            [attr.name]="name"
            [disabled]="disabled"
            [formControl]="control"
            [placeholder]="placeholder"
            [type]="type"
            (blur)="onTouched()"
            (input)="handleInput(input.value)"
        />
        <span matPrefix>
            <ng-content matPrefix select="[prefix]"></ng-content>
        </span>

        <span matSuffix>
            <ng-container *ngIf="control?.invalid && (control.touched || control.dirty); else customSuffixTemplate">
                <mat-icon class="error-icon" fontSet="material-symbols-outlined">error</mat-icon>
            </ng-container>

            <ng-template #customSuffixTemplate>
                <ng-content matSuffix select="[suffix]"></ng-content>
            </ng-template>
        </span>

        <mat-error>
            <ng-content select="mat-error"></ng-content>
        </mat-error>

        <mat-hint>
            <ng-content select="mat-hint"></ng-content>
        </mat-hint>
    </mat-form-field>
</div>
